// import core components
import { useState, Fragment, useRef, useEffect } from "react";
import { useRouter } from "next/router";

// import custom components
import Button from "@/elements/Shared/Button";
import LinkNav from "@/elements/LinkNav";

// import menu data
import menu from "src/data/layout/menu.json";

// import styles
import styles from "./menuDesktop.module.scss";

// import svg
import DistrictWeb from "@/elements/Shared/SVGs/DistrictWeb";
import RightArrow from "@/elements/Shared/SVGs/RightArrow";
import ChevronBottom from "@/elements/Shared/SVGs/ChevronBottom";

type Props = {
  color: string;
};

export default function MenuDesktop(props: Props) {
  const [toggleDropdown, setToggleDropdown] = useState(false);
  const router = useRouter();
  const dropdownRef = useRef(null);

  useEffect(() => {
    dropdownRef.current.addEventListener("mouseenter", () => {
      setToggleDropdown(true);
    });
  });

  useEffect(() => {
    dropdownRef.current.addEventListener("mouseleave", () => {
      setToggleDropdown(false);
    });
  });

  return (
    <nav className={styles._nav}>
      <div
        className={`container ${styles._container} ${
          styles[`_color_${props.color}`]
        }`}
      >
        {router.asPath !== "/" ? (
          <LinkNav
            path="/"
            ariaLabel="District web page d'accueil"
            className={styles._logo_district_web}
          >
            <DistrictWeb color={props.color} />
          </LinkNav>
        ) : (
          <div className={styles._logo_district_web}>
            <DistrictWeb color={props.color} />
          </div>
        )}

        <ul id="main-menu" className={`${styles._main_menu}`}>
          {menu.menus.map((menu) => {
            if (menu.children.length > 0) {
              return (
                <li
                  key={menu.title}
                  ref={dropdownRef}
                  className={`${styles._menu_items} ${styles._dropdown} ${
                    router.asPath === menu.lien ? styles["active"] : ""
                  } menu-items`}
                >
                  <LinkNav
                    path={menu.lien}
                    setToggle={setToggleDropdown}
                    className={styles._menu_link}
                  >
                    <>{menu.title}</>
                  </LinkNav>
                  <span
                    className={`${styles._toggle} ${
                      toggleDropdown
                        ? styles._toggle_open
                        : styles._toggle_close
                    }`}
                    onClick={() => {
                      setToggleDropdown(!toggleDropdown);
                    }}
                  >
                    <ChevronBottom />
                  </span>
                  <ul
                    className={`${styles._dropdown_container} ${
                      toggleDropdown ? styles["open"] : ""
                    } `}
                  >
                    {menu.children.map((child, i) => {
                      return (
                        <Fragment key={child.title}>
                          <li className={styles._dropdown_items}>
                            <LinkNav
                              path={child.lien}
                              setToggle={setToggleDropdown}
                            >
                              <>
                                {child.title}
                                <span>
                                  <RightArrow />
                                </span>
                              </>
                            </LinkNav>
                          </li>
                        </Fragment>
                      );
                    })}
                  </ul>
                </li>
              );
            } else {
              return (
                <li
                  className={`${styles._menu_items} ${
                    router.asPath === menu.lien
                      ? styles["active"] + " actif"
                      : ""
                  } menu-items`}
                  key={menu.title}
                >
                  <LinkNav path={menu.lien} setToggle={setToggleDropdown}>
                    {menu.title}
                  </LinkNav>
                </li>
              );
            }
          })}
        </ul>

        <Button
          path="/contact"
          bg={"transparent"}
          color={props.color}
          border={props.color}
          icon={false}
          is3dFlip={false}
          id="contact-btn"
          className={styles["contact-btn"]}
        >
          <>
            <span
              id="menu-contact-btn-overlay"
              className={styles["contact-btn-overlay"]}
            ></span>
            Contact
          </>
        </Button>
      </div>

      <span
        id="menu-separateur"
        className={`${styles._separator} ${
          props.color === "black" ? styles._alternative : ""
        }`}
      ></span>
    </nav>
  );
}
